export const COMMUNICATION_PLUGIN_ENABLED = process.env.COMMUNICATION_PLUGIN_ENABLED === 'true';
